import { create } from "zustand"

const TOTAL_STEPS = 5

interface TourStore {
  active: boolean
  stepIndex: number
  start: () => void
  next: () => void
  back: () => void
  skip: () => void
  reset: () => void
}

export const useTourStore = create<TourStore>((set) => ({
  active: false,
  stepIndex: 0,
  start: () => set({ active: true, stepIndex: 0 }),
  next: () =>
    set((s) => {
      if (s.stepIndex >= TOTAL_STEPS - 1) return { active: false, stepIndex: 0 }
      return { stepIndex: s.stepIndex + 1 }
    }),
  back: () => set((s) => ({ stepIndex: Math.max(0, s.stepIndex - 1) })),
  skip: () => set({ active: false, stepIndex: 0 }),
  reset: () => set({ active: false, stepIndex: 0 }),
}))
